import React from "react";
import PropTypes from 'prop-types';

class CustomizedTooltip  extends React.Component{

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label } = this.props;
      return (
        <div className="custom-tooltip">
          <p> { `${label}` } </p>
          <p style={ { color: '#7070d0' } }> { `Sovos Tax: ${payload[0].value }` } </p>
          <p style={ { color: '#70b090' } }> { `Vendor Tax : ${payload[1].value }` } </p>
          <p style={ { color: '#70b0f0' } }> { `Variance : ${ (payload[1].value - payload[0].value ).toFixed(2) }` } </p>
        </div>
      );
    }
    return null;
  }
}

CustomizedTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.string,
  active: PropTypes.bool
};

export default CustomizedTooltip;


// WEBPACK FOOTER //
// ./src/components/dashboard/comp/vendorOverchargesChart/CustomizedTooltip.js